import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "../assests/scss/travelpass.scss";
import {
  basicDetails,
  getApiData,
  postApiCall,
  getCountry,
} from "../actions/corporateSignupAction";
import LoaderSpinner from "../components/LoaderSpinner";
const CorporateSignup = (props) => {
  const getMarketLanguage = () => {
    const href = window.location.href
    if (href.match(/.+\.sas\.se/)) {
        return "se-sv"
    } else if (href.match(/.+\.sas\.no/)) {
        return "no-no"
    } else if (href.match(/.+\.sas\.dk/)) {
        return "dk-da"
    } else if (href.match(/.+\.sas\.fi/)) {
        return "fi-en"
    } else if (href.match(/\/resmal\//)) {
        return "se-sv"
    } else if (href.match(/\/reisemal\//)) {
        return "no-no"
    } else if (href.match(/\/rejsemaal\//)) {
        return "dk-da"
    }

    return getMarketByPathname(href).toLowerCase()

}
  const getMarketByPathname = (href) =>  {
      return (href.match(/\/([a-z]{2}-[a-z]{2})(\/|$).*/i) || [])[1] || "lu-en"
  }
  const marketLang = getMarketLanguage().split("-");

  const allowedMarkets = ['se', 'no', 'dk', 'fi', 'gb']
  if(allowedMarkets.indexOf(marketLang[0]) === -1){
    window.location.href = "https://sas.fi/en/buy-travelpass";
  }
  const [companyDetailsResponse, setcompanyDetailsResponse] = useState();
  const travelpassEngagement = () => {
    if (sessionStorage["prof-profile"]) {
      let profileData = JSON.parse(sessionStorage["prof-profile"]);
      let activeTP;
      profileData.engagements?.travelPass
        ? profileData.engagements.travelPass.length > 0
          ? profileData.engagements.travelPass.map((item) => {
              if (item.statusCode.toUpperCase() === "ACTIVE") {
                activeTP = item;
              }
            })
          : (activeTP = {})
        : (activeTP = {});
      return activeTP.id;
    }
  };

 
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  const isDevEnvironment = () => {
    return (
      window.location.hostname === "localhost" ||
      window.location.hostname.match(/\.local/) ||
      window.location.hostname.match(/^10\..+/)
    );
  };
  const isTestEnvironment = () => {
    return !!window.location.hostname.match(/test\./);
  };
  const apiPath = () => {
    return isDevEnvironment() || isTestEnvironment()
      ? "https://api2.test.flysas.com"
      : "https://api2.flysas.com";
  };

  const getTravelPassDetails = (orgNo) => {
    const req = {
      url: `${apiPath()}/travelpass/v1/user/${orgNo}`,
      headers: {
        Authorization: cookieLogin(),
        "content-type": "application/json",
      },
    };
    return new Promise((resolve, reject) => {
      getApiData(req)
        .then((data) => {
          resolve(data);
          if (data.errors) {
          } else {
            setcompanyDetailsResponse(data);
          }
        })
        .catch((error) => {});
    });
  };
  const cookieLogin = () => {
    return isDevEnvironment()
      ? "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik9WMUN6LTV4ZHRoR0ZUNGNTLURZdiJ9.eyJjdXN0b21lcklkIjoiMTE5NTQ2NTgiLCJzZXNzaW9uSWQiOiIxMTk1NDY1OCwyMDI0LTAyLTI3IDEwOjM5OjE4LDMwLDEwLGViaXFtSUlmN3Qzd3FKZjhzcjJtZGNsNGVRZ1RObWlCNmZoKzdQUzlhZHpsTGgyZWM5djhQTjArdUZnSUtad2YiLCJjdXN0b21lclNlc3Npb25JZCI6Ijg3OTZkZWYwZjQwNTQwOGU5MDQ2OTMwYTEwM2IyMjM0IiwiY3VzdG9tZXJUeXBlIjpbImV1cm9Cb251cyIsInRyYXZlbFBhc3MiXSwiZXVyb0JvbnVzTnIiOiI1NDQzMjE2NDkiLCJ0cmF2ZWxQYXNzTnIiOiI5MjcyMjk2MDkiLCJjb3Jwb3JhdGUiOiJ0cnVlIiwiaXNzIjoiaHR0cHM6Ly9hdXRoLXN0YWdlLmZseXNhcy5jb20vIiwic3ViIjoiYXV0aDB8Y29kcy1jdXN0b21lci1pZC8xMTk1NDY1OCIsImF1ZCI6WyJmbHlzYXMtYXBpIiwiaHR0cHM6Ly9zdGFnZS1mbHlzYXMuZXUuYXV0aDAuY29tL3VzZXJpbmZvIl0sImlhdCI6MTcwOTAzMDM1OSwiZXhwIjoxNzA5MTE2NzU5LCJhenAiOiJ2cnNsS1EzOE9zeWc5a0Q4TFpiTGJYRlJHWFFuTTdPSiIsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwifQ.D2t7-rOVI1WUPY4EDEQvxoYhhqeIOWRbIvp5AaZpqbPbxW0KZ3-Wc33v5x-qFkh8102dDyOL4ySpd7GYoQ2dD0g83O8D1YjcsCoE2k5kWsaEe6u7xd2-ZPXfSFY4-1wCvXChzCA0luXdKz0756UkHWTqfTFjVZkMVWOBAas8TYr13eXcel1wWVaaVgSTC-BjstVtWXscIE2WXULcPWoF4J2BtuMA4ej5X49bv5o4VNJNgYJX_nXMU4hfXTKk0IW00gDjMw6bkpI_LoUSdjgHKRd9bm9_dZfk9YOUfhWW2SyEMelKLWZHUOpv8gW0SMDuLnvsyKB-7iJhngrY34et_g"
      : getCookie("LOGIN_AUTH");
  };
  useEffect(() => {
    const profSession = JSON.parse(sessionStorage.getItem("prof-profile"));
    if(profSession){
      getTravelPassDetails(travelpassEngagement());
    }
    
  }, []);
 const profSession = JSON.parse(sessionStorage.getItem("prof-profile"));
//   if (!profSession) {
//     window.location.href = "/login";
//   }
//   const companyName = profSession?.corporateMemberEngagement
//     ? profSession?.corporateMemberEngagement?.corporateMember[0]?.companyName
//     : companyDetailsResponse.organisations[0].name;

    const companyName =  companyDetailsResponse?.organisations[0]?.name;

  return (
    <>
      <LoaderSpinner />
      <div className="tp-shop-header">
        <div className={profSession ? 'company-info' : 'company-info-withoutLogin company-info'}>
          <div>
            <h2>{profSession ? 'WELCOME BACK' : 'WELCOME'}</h2>
          </div>
          <div>
            <h1>{companyName}</h1>
          </div>
        </div>
        <div>
          <img
            src="https://images.ctfassets.net/oz9qk43ly6yk/4DrNga65gEr0xBhwPKLbtK/05f31cfb835da9d0799343a8689d2206/usa-washington-city-buildings.png"
            className="tpshop"
          ></img>
        </div>
      </div>
      <div className="sas-container inner-wrapper">
        <tp-sales integrated="true"></tp-sales>
      </div>
    </>
  );
};
const mapStateFromReducer = (state) => ({
  ...state,
  labels: state.corporateSignupReducer.labels || {},
  getSessionStorage: state.corporateSignupReducer.getSessionStorage || {},
  countryName: state.corporateSignupReducer.country || {},
});

const mapDispatchToActions = (dispatch) => ({
  getCountry: (requestBody) => dispatch(getCountry(requestBody)),
  basicDetails: (body) => dispatch(basicDetails(body)),
  getApiData: (req) => dispatch(getApiData(req)),
  postApiCall: (req) => dispatch(postApiCall(req)),
});

export default connect(
  mapStateFromReducer,
  mapDispatchToActions
)(CorporateSignup);
